import { render } from "./OrdersList.vue?vue&type=template&id=7414bfe3&scoped=true"
import script from "./OrdersList.vue?vue&type=script&lang=ts"
export * from "./OrdersList.vue?vue&type=script&lang=ts"

import "./OrdersList.vue?vue&type=style&index=0&id=7414bfe3&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7414bfe3"

export default script